import { render } from "./DTable.vue?vue&type=template&id=180a5a33&scoped=true&lang=pug"
import script from "./DTable.vue?vue&type=script&lang=js"
export * from "./DTable.vue?vue&type=script&lang=js"

import "./DTable.vue?vue&type=style&index=0&id=180a5a33&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180a5a33"]])

export default __exports__